import React from 'react';
import { render } from "preact";
import {BaseComponent} from "../../../../project/general";
import {AHDropdown} from "./dropdown";
import {SearchFilters} from "../../../service-directory-search-results-page/js/filtering/search-filters";

class HeritageSearchFiltersComponent  extends BaseComponent {

    static getRequiredRefs() {
        return [
            'filter_definitions'
        ]
    }

    static getNamespace() {
        return 'heritage-search-filters';
    }

    onInit() {
        let filterOpts = JSON.parse(this.refs.filter_definitions.innerHTML)

        console.log(filterOpts)

        render(
            filterOpts.filters.map((filter) => (
                    <AHDropdown filterOpts={filter}></AHDropdown>
            )),
            this.element
        )
    }
}

export default HeritageSearchFiltersComponent;
